.root {
  display: inline-flex;
  outline: 0;
}
